import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ItemWrapper = styled.div<{ isSelected: boolean }>`
  display: flex;
  padding: 14px 16px;
  align-items: center;
  flex: 1 0 0;
  border-radius: 4px;
  border: 1px solid;
  background: ${({ theme }) => theme.colors.white};
  border-color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.green6 : theme.colors.black4};
  background: ${({ theme, isSelected }) => (isSelected ? theme.colors.green1 : theme.colors.white)};
  transition: background 0.3s, border 0.1s;
  cursor: pointer;

  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green6};
    background: ${({ theme }) => theme.colors.green1};
    &:hover {
      border-color: ${({ theme }) => theme.colors.green6};
      background: ${({ theme }) => theme.colors.green1};

      .ant-checkbox-inner {
        border-color: ${({ theme }) => theme.colors.green6};
      }
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
    &:hover {
      background-color: ${({ theme }) => theme.colors.green6};
      border-color: ${({ theme }) => theme.colors.green6};
    }
  }
  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.black4};
  }
  &:hover {
    .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.colors.green6};
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: white;
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.green6} !important;
  }

  &:hover .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  .ant-checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;

    span {
      padding: 0;
    }
  }
`;
